// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"8863e5cf","490":"2b67b88f","675":"2cbce437","787":"fa235f9c","798":"aa3c4990"}[chunkId] + ".chunk.js";
};